import { render, staticRenderFns } from "./TagCustomColorPicker.vue?vue&type=template&id=6568d1aa&scoped=true"
import script from "./TagCustomColorPicker.vue?vue&type=script&lang=js"
export * from "./TagCustomColorPicker.vue?vue&type=script&lang=js"
import style0 from "./TagCustomColorPicker.vue?vue&type=style&index=0&id=6568d1aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568d1aa",
  null
  
)

export default component.exports